function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 402",
  d: "M48.1 124.26c30.43 0 47.6-25.16 47.6-61.88S78.53.5 48.1.5C17.84.5.5 25.66.5 62.38s17.34 61.88 47.6 61.88zm0-22.95c-15.98 0-24.14-13.77-24.14-38.93s8.16-39.1 24.14-39.1 24.31 13.94 24.31 39.1-8.33 38.93-24.31 38.93zm108.8-50.15l22.27-28.9V2.88h-74.8v21.93h46.58l-23.46 30.6 9.01 13.6h5.1c12.24 0 19.04 6.63 19.04 16.15 0 9.69-6.8 16.15-19.04 16.15-11.22 0-17.85-4.93-20.74-13.77L100.8 99.1c6.8 17 22.95 25.16 40.8 25.16 22.44 0 42.5-13.6 42.5-39.1 0-17.51-11.73-29.41-27.2-34z",
  fill: "none",
  stroke: "#3c00dc"
});

function SvgNumber03Inline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 184.6,
    height: 124.76,
    viewBox: "0 0 184.6 124.76"
  }, props), _ref);
}

export default SvgNumber03Inline;